import { Moment } from 'moment';

import { makeMoment } from './Model';

export class PatientGuideDetails {
  initiatingVisit?: Moment;

  visitStatus?: string;

  firstName?: string;

  lastName?: string;

  relationship?: string;

  phoneNumber?: string;

  invalidPhoneNumber?: boolean;

  phoneType?: string;

  livesWithMember?: boolean;

  isEmpty: boolean;

  createdAt?: number;

  constructor(obj: any) {
    Object.assign(this, obj);
    this.initiatingVisit = makeMoment(obj.initiatingVisit);
    this.firstName = obj?.firstName;
    this.lastName = obj?.lastName;
    this.relationship = obj?.relationship;
    this.phoneNumber = obj?.phoneNumber;
    this.invalidPhoneNumber = obj?.invalidPhoneNumber;
    this.phoneType = obj?.phoneType;
    this.livesWithMember = obj?.livesWithMember;
    this.isEmpty = Object.keys(obj || {}).length === 0;
    this.visitStatus = obj?.visitStatus;
    this.createdAt = obj?.createdAt;
  }
}

export default PatientGuideDetails;
